interface Image {
  url: string
  width: number
}

const variantToSrcSet = (variant: Image) => `${variant.url} ${variant.width}w`

export const variantsToSrcSet = (variants: Image[]) => variants.map(variantToSrcSet).join(",\n")
